// These values must always be kept in sync with those of the less folder
// src/themes/RIO/css/mapping/positions-map.scss

export const positions = {
    px: ['0', '1', '2', '3', '4', '5', '10', '15', '20', '25'],
    pct: ['10', '20', '25', '30', '40', '50', '60', '70', '75', '80', '90', '100'],
};
